var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body text-center",staticStyle:{"padding":"50px 0"}},[_c('h1',{staticStyle:{"font-size":"36px"}},[_vm._v("\n            "+_vm._s(_vm.greeting)+", "+_vm._s(_vm.name)+"!\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }